/**
 * BookingCancelled.js - Page shown when payment was cancelled
 */
import React from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw, Home } from 'lucide-react';
import { Button } from '../components/ui/button';

const BookingCancelled = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const pendingId = searchParams.get('pending_id');

  return (
    <div className="min-h-screen bg-[var(--background)] flex items-center justify-center p-4">
      <div className="card max-w-md w-full p-8 text-center">
        <XCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
        
        <h1 className="text-2xl font-bold mb-2">Payment Cancelled</h1>
        <p className="text-[var(--text-muted)] mb-6">
          Your payment was not completed. No charges have been made to your card.
        </p>

        <div className="space-y-3">
          <Button 
            onClick={() => navigate('/guest-checkout')}
            className="w-full btn-primary"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Try Again
          </Button>
          
          <Button 
            variant="outline"
            onClick={() => navigate('/')}
            className="w-full"
          >
            <Home className="w-4 h-4 mr-2" />
            Return Home
          </Button>
        </div>

        <p className="mt-6 text-sm text-[var(--text-muted)]">
          Need help? Contact us at{' '}
          <a href="mailto:support@nchelphub.com" className="text-[var(--primary)]">
            support@nchelphub.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default BookingCancelled;
